import axios from '../Backend';

export const googleLogin = async (credential) => {
    if(!credential) throw new Error('credential not exist')
    const res = await axios.post('/api/v2/channels/google/auth', credential);
    const resDate = res.data
    if (resDate?.status !== 'success') throw Error('Error to login google')
    return resDate
}

export const youtubeSyncVideoComments = async (videoId) => {
    if(!videoId) throw new Error('videoId not exist')
    const res = await axios.post(`/api/v2/channels/google/youtube/sync-comments/${videoId}`);
    const resDate = res.data
    if (resDate?.status !== 'success') throw Error(`Error to sync video ID:${videoId} Comments`)
    return resDate
}

// export const googleLogout = async (userID) => {
//     try {
//         axios.get('/channels/facebook/logout?userID=' + userID);
//     } catch (e) {
//         console.log('dispatch onFacebookUserLogin fail')
//     }

// }